var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    ref: "checkbox",
    attrs: { id: _vm.context.id, type: "checkbox" },
    domProps: { checked: _vm.checkedState === true },
    on: {
      input: function($event) {
        $event.preventDefault()
        return _vm.toggle.apply(null, arguments)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }